// extracted by mini-css-extract-plugin
export var newsList = "styles-module--newsList--5yPkj";
export var fadeIn = "styles-module--fadeIn--m1gJA";